/*
 * @Author: wangping wangping@gdtwzc.com
 * @Date: 2023-10-16 09:01:35
 * @LastEditors: ping
 * @LastEditTime: 2023-10-22 18:54:00
 * @FilePath: \test44\my-vue-app\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/introPage",
    name: "introPage",
    component: () => import("@/views/introPage/introPage.vue"),
    meta: {
      title: "引导页",
      keepAlive: true,
    },
  },
  // {
  //   path: "/index2",
  //   name: "index2",
  //   component: () => import("@/views/index/index2.vue"),
  //   meta: {
  //     title: "首页",
  //     keepAlive: true,
  //   },
  // },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index/index.vue"),
    meta: {
      title: "首页",
      keepAlive: true,
    },
  },
  {
    path: "/help",
    name: "help",
    component: () => import("@/views/help/help.vue"),
    meta: {
      title: "帮助中心",
      keepAlive: true,
    },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: () => import("@/views/feedback/index.vue"),
    meta: {
      title: "我的反馈",
      keepAlive: true,
    },
  },
  {
    path: "/filePreview",
    name: "filePreview",
    component: () => import("@/views/filePreview/index.vue"),
    meta: {
      title: "文件预览",
      keepAlive: true,
    },
    beforeEnter: (to, from) => {
      // reject the navigation
      console.log(to, from, "11111111111");
      if (!to.query?.url) {
        // 重定向到首页
        return {
          path: "/index",
        };
      } else {
        console.log(to, from, "99999999999");
      }
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404/404.vue"),
    meta: {
      title: "404",
      keepAlive: true,
    },
  },
  // {
  //     path: '*',
  //     redirect: '/404'
  // }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log(to, from, next, 888888888);
  // if (to.path === '/index') {
  //     next()
  // } else {
  if (to.path === "/") {
    next("/index");
  } else if (to.path === "/filePreview") {
    if (!to.query?.url) {
      next("/index");
      return false;
    }
    next();
  } else {
    next();
  }
  // }
});

router.afterEach((to, from) => {
  console.log(to);
  console.log(from);
  console.log("路由跳转完成");
  console.log("------------------");
});

export default router;
